module.exports = __webpack_public_path__ + "img/legalServices-8.bae3a805.png";